import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';

const CoachRequestsDialog = ({ open, onClose, requests, userId }) => {
  const [responses, setResponses] = useState({}); // coach_id: "accepted" | "rejected"

  const handleRespond = (id, status) => {
    setResponses((prev) => ({ ...prev, [id]: status }));
  };

  const handleAcceptAll = () => {
    const allAccepted = Object.fromEntries(requests.map((r) => [r.coach_id, 'accepted']));
    setResponses(allAccepted);
  };

  const handleRejectAll = () => {
    const allRejected = Object.fromEntries(requests.map((r) => [r.coach_id, 'rejected']));
    setResponses(allRejected);
  };

  const handleSubmit = () => {
    const results = requests.map((req) => ({
      coach_id: req.coach_id,
      status: responses[req.coach_id] || 'pending',
    }));

    axios.post(`${process.env.REACT_APP_API_HOST}/api/coach-requests/respond`, results)
        .catch(err => console.log(err));

    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Coach Requests</DialogTitle>
      <DialogContent dividers>
        {requests.length === 0 ? (
          <Typography>No coach requests.</Typography>
        ) : (
          <List>
            {requests.map((req) => (
              <ListItem key={req.coach_id} divider>
                <ListItemText
                  primary={req.coach_name}
                />
                <ListItemSecondaryAction>
                  <Stack direction="row" spacing={1}>
                    <IconButton
                      color={responses[req.coach_id] === 'accepted' ? 'success' : 'default'}
                      onClick={() => handleRespond(req.coach_id, 'accepted')}
                    >
                      <CheckIcon />
                    </IconButton>
                    <IconButton
                      color={responses[req.coach_id] === 'rejected' ? 'error' : 'default'}
                      onClick={() => handleRespond(req.coach_id, 'rejected')}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Stack>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button onClick={handleAcceptAll}>Accept All</Button>
        <Button onClick={handleRejectAll}>Reject All</Button>
        <Button onClick={handleSubmit} variant="contained" color="primary">
          Submit
        </Button>
        {/* <Button onClick={onClose} color="secondary">Cancel</Button> */}
      </DialogActions>
    </Dialog>
  );
};

export default CoachRequestsDialog;
